module.exports = {
	"og:type": "website",
	"og:title": "Identity infrastructure, built for developers",
	"og:site_name": "Auth0",
	"og:description": "A universal identity platform for customers, employees and partners",
	"og:locale": "en_US",
	"og:url": "https://auth0.com",
	"og:image": "https://cdn.auth0.com/website/assets/modules/opengraph/1x-new-69e09d5054.png",
	"og:image:secure_url": "https://cdn.auth0.com/website/assets/modules/opengraph/1x-new-69e09d5054.png",
	"fb:app_id": "507756515938786"
};


//////////////////
// WEBPACK FOOTER
// ./src/modules/opengraph/defaults.json
// module id = 1096
// module chunks = 0